import React, { useReducer } from "react"
import { ImportacaoClientesInicial } from "../models/importacaoClientesModel"
import { ImportacaoClientesContext } from "./ImportacaoClientesContext"
import { importacaoClientesReducer } from "./importacaoClientesReducer"

export function ImportacaoClientesContextProvider({ children }: { children: React.ReactNode }) {
    const [dados, dispatch] = useReducer(importacaoClientesReducer, ImportacaoClientesInicial)

    return (
        <ImportacaoClientesContext.Provider value={{ dados, dispatch }}>
            {children}
        </ImportacaoClientesContext.Provider>
    )
}
